export const FOCUS_OR_VALUE_CLASSNAME = 'has-focus-or-value'
export const ERROR_CLASSNAME = 'has-error'
export const HAS_JS_CLASSNAME = 'has-js'
